var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    directives: [
      {
        name: "loading",
        rawName: "v-loading",
        value: _vm.loading,
        expression: "loading"
      }
    ],
    staticClass: "checkToken",
    attrs: { "element-loading-background": "rgba(0,0,0,0.3)" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }